import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  text: "",
  error: "",
};

export const messageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {
    setMessage: (state, action) => {
      state.text = action.payload.text;
      state.error = action.payload.error;
    },
    clearMessage: (state) => {
      state.text = "";
      state.error = "";
    },
  },
});

export const { setMessage, clearMessage } = messageSlice.actions;
export default messageSlice.reducer;
